import script from "./contentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./contentItem.vue?vue&type=script&setup=true&lang=js"

import "./contentItem.vue?vue&type=style&index=0&id=1a4e9c03&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a4e9c03"]])

export default __exports__